import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { PesquisaMapa } from 'src/app/base/domain/pesquisa-mapa.model';
import { PesquisaMapaFormComponent } from '../../pesquisa-mapa-form-cadastrar/pesquisa-mapa-form.component';
import { MatDialog } from '@angular/material/dialog';
import { PesquisaMapaService } from 'src/app/base/services/pesquisa-mapa-service';
import { HttpErrorResponse } from '@angular/common/http';
import { DialogService } from 'src/app/global/services/dialog.service';
import { EstabelecimentoFormComponent } from '../../estabelecimento-form/estabelecimento-form/estabelecimento-form.component';

export interface PesquisaMapaEvent {
  acao: string;
  pesquisaMapa: PesquisaMapa;
}
export interface PesquisaMapaFilterOptions {
  dataInicial: Date;
  dataFinal: Date;
}

@Component({
  selector: 'app-pesquisa-mapa-list',
  templateUrl: './pesquisa-mapa-list.component.html',
  styleUrls: ['./pesquisa-mapa-list.component.css']
})
export class PesquisaMapaListComponent {

  @Input() page: any = { content: [] };
  @Input() totalRecords = 0;
  @Input() rowsNumber = 10;
  @Input() loading = false;

  @Output() atualizar = new EventEmitter<void>();
  @Output() loadPage = new EventEmitter<number>();
  @Output() novo = new EventEmitter<void>();
  @Output() acaoMenu = new EventEmitter<void>();
  @Output() Oncadastro = new EventEmitter<void>();

  menuAcoes: string[] = ['Cadastrar Pesquisa'];

    filterOptions: PesquisaMapaFilterOptions;
    private readonly defaultFilterOptions: PesquisaMapaFilterOptions = {
      dataInicial: null,
      dataFinal: null,
    };

  currentPage = 0;

  constructor(private dialog: MatDialog,
    private service: PesquisaMapaService,
    private dialogService: DialogService
  ) {}

  loadPesquisas(event: LazyLoadEvent): void {
    const pageNumber = Math.floor(event.first / event.rows);
    this.currentPage = pageNumber;
    this.loadPage.emit(pageNumber);
  }

  onAtualizar(): void {
    this.atualizar.emit();
  }

  visualizarPesquisa(pesquisa: any): void {
    alert(`Visualizar pesquisa: ${pesquisa.numeroPesquisaMapa}`);
  }

  onMenuAcaoClick($event: any) {
     this.acaoMenu.emit($event);
}
  onAcaoClick (tipo,dados){
  this.Oncadastro.emit(dados);
      this.dialog
              .open(EstabelecimentoFormComponent, {
                height:'800px',
                width: '800px',
                data: dados
              })
              .afterClosed()
              .subscribe((form) => {
                if (form) {
                  this.service.createEstabelecimento(form).subscribe(
                    (response) => {
                      if (response) {
                        this.dialogService.feedbackSuccess('Pesquisa Cadastrada com Sucesso!');
                      }
                    },
                    (error: HttpErrorResponse) => {
                      this.dialogService.feedbackError('Ocorreu um erro ao cadastrar Pesquisa: ' + error.error);
                    },
                  );
                }
              });
  }
}

